import React, { useMemo } from "react";

export default function MiniTableSubtitleRow({
  miniTableProperties = [],
  miniTableDateRange = "",
  mlsAreaID,
}) {
  const subtitleSummary = useMemo(() => {
    const activeListings = miniTableProperties.filter(
      (p) => p?.status === "Active",
    ).length;
    const pendingListings = miniTableProperties.filter(
      (p) =>
        p?.status === "Pending" ||
        p?.status === "Contingent" ||
        p?.status === "ActiveContingent",
    ).length;

    return {
      activeListings,
      pendingListings,
    };
  }, [miniTableProperties]);

  return (
    <div className="subtitle-row">
      <div className="left-subtitle-section">
        <div className="left-subtitle-text">
          <p className="small-left-subtitle">{miniTableDateRange}</p>
        </div>
        {mlsAreaID === "SMA-470" && (
          <div className="central-subtitle-section">
            <p>Current Market:</p>
          </div>
        )}
        {(subtitleSummary.activeListings > 0 ||
          subtitleSummary.pendingListings > 0) && (
          <div className="right-subtitle-section">
            <p>Active Listings: {subtitleSummary.activeListings}</p>
            <div className="right-subtitle-divider">|</div>
            <p>Pending: {subtitleSummary.pendingListings}</p>
          </div>
        )}
      </div>
      {/*<img
        src="https://d2onbxnrte2nim.cloudfront.net/non-covers/032526_Dotted-Lines_1_8-95+in_dottedLine.png"
        alt=""
        className="golden-divider extra-long"
      />*/}
    </div>
  );
}
